import React, { useState, useEffect } from 'react';
import ReportCreateResult from '../report-create-page/ReportCreateResult';
import ReportInformation from './ReportInformation';
import ReportList from './ReportList';

import './ReportManagerMain.css';

const ReportManagerMain = (props) => {
  const [reportLabelData, setReportLabelData] = useState();
  const [selectedReport, setSelectedReport] = useState();
  const [selectedReportQuery, setSelectedReportQuery] = useState();
  const [queryData, setQueryData] = useState();

  useEffect(()=>{
    setReportLabelData(props.reportLabelData);
  }, [props.reportLabelData]);

  useEffect(()=>{
    setSelectedReport(props.selectedReport);
  },[props.selectedReport]);

  useEffect(()=>{
    setQueryData(props.queryData);
  },[props.queryData])

  useEffect(()=>{
    setSelectedReportQuery(props.selectedReportQuery);
  }, [props.selectedReportQuery]);

  return (
    <div className="row featured-main">
      <div className="manageReportBoxLR">
        <table width="100%" border="0" cellspacing="0" cellpadding="0">
          <tr>
            <td width="22%" valign="top">
                {reportLabelData &&
                  <div id="manageReportLeft">
                    <ReportList handleClick={props.handleSelectedReport} reportLabelData={reportLabelData}
                      handleSearchBtn={props.handleSearchBtn} reportFilter={props.reportFilter} handleSearchInput={props.handleSearchInput} filteredArray={props.filteredArray}
                    />
                  </div>
                }
            </td>
            <td width="78%" valign="top">
              {selectedReport && selectedReportQuery && queryData &&
                <div id="manageReportRight">
                  <ReportInformation reportInfo={selectedReport} queryData={queryData} selectedReportQuery={selectedReportQuery}
                  handleRemoveBtn={props.handleRemoveBtn} handleRunBtn={props.handleRunBtn}
                />
                </div>
              }
              <div id="reportResult">
                <ReportCreateResult data={props.resultData} options={props.options} userRole={props.userRole} />
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  )
}

export default ReportManagerMain;